import React, { forwardRef } from 'react'
import { SvgIcon, SvgIconProps } from '@mui/material'

const Note = forwardRef<SVGSVGElement, SvgIconProps>(function Note(props, ref) {
  return (
    <SvgIcon ref={ref} {...props}>
      <path d="m12.544472,8.282045l-1.28571,1.28571l-4.47857,0c-0.35424,0 -0.64286,0.28795 -0.64286,0.64286l0,0l0,6.14263c0,0.35491 0.28795,0.64286 0.64286,0.64286l0,0l8.28548,0c0.35424,0 0.64286,-0.28795 0.64286,-0.64286l0,0l0,-3.15598l1.28571,-1.28505l0,4.44172c0,1.06339 -0.86518,1.92857 -1.92857,1.92857l0,0l-8.28548,0c-1.06339,0 -1.92857,-0.86518 -1.92857,-1.92857l0,0l0,-6.14332c0,-1.06339 0.86518,-1.92857 1.92857,-1.92857l0,0l5.76428,0zm4.00653,-2.18787c0.50148,-0.50224 1.31576,-0.50224 1.818,0l0,0l0.40329,0.40328c0.50156,0.50215 0.50156,1.31644 -0.00067,1.818l0,0l-6.26246,6.26314c-0.5016,0.50224 -2.98534,1.25759 -3.23177,1.01049c-0.24643,-0.24651 0.50892,-2.72954 1.01115,-3.23177l0,0l6.26246,-6.26314z" />
    </SvgIcon>
  )
})

export default Note
